// extracted by mini-css-extract-plugin
export default {"name":"UnqualifiedRow_name__jD79J","remaining":"UnqualifiedRow_remaining__6qxwx"};